export default {
  title: 'Avez-vous SOSAFE?',
  subtitle: 'Si oui, essayez les messages privés de SOSAFE',
  action: 'OUI',
};
